export default "__VITE_ASSET__C1ai3xOD__"